export { watchGetAssetInformationDerivatives as getAssetInforDerivatives } from './AssetInforDerivatives/saga';
export { watchGetAssetInformation as getAssetInformation } from './AssetInforEquity/saga';



// WEBPACK FOOTER //
// ./src/components/areas/Account/AssetInformation/sagas.ts